import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssessmentCompletionTemplate from '../components/AssessmentCompletionTemplate';
import { createAssessmentConfig } from '../config/assessmentCompletionConfigs';

interface OccupationalAssessmentResult {
  id: string;
  assessmentType: string;
  scores: {
    overall: number;
    category1: number; // CBI
    category2: number; // UWES
    category3: number; // Employee Engagement & Climate
    engagementTotal?: number; // Employee Engagement raw score (for reversal)
  };
  results: {
    level: 'Low' | 'Moderate' | 'High';
    interpretation: string;
    recommendations: string[];
  };
  createdAt: string;
}

const OccupationalAssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const assessmentResult = location.state?.assessmentResult as OccupationalAssessmentResult;
  
  if (!assessmentResult || !assessmentResult.scores || !assessmentResult.results) {

    navigate('/panel/learn/');
    return null;
  }

  try {
    const assessmentType = assessmentResult.assessmentType;
    const isCBI = assessmentType === 'cbi';
    const isUWES = assessmentType === 'uwes';
    const isEngagement = assessmentType === 'employee-engagement';

    // Reverse scoring for Employee Engagement
    let scoreLabel = isCBI ? 'Occupational Burnout' : isUWES ? 'Occupational Burnout' : isEngagement ? 'Engagement Score' : 'Engagement Score';
    let assessmentName = isCBI ? 'CBI (Copenhagen Burnout Inventory) Assessment' : isUWES ? 'UWES Assessment' : isEngagement ? 'Employee Engagement Assessment' : 'Occupational Assessment';

    let scores = assessmentResult.scores;
    if (isEngagement) {
      // Reverse the engagement score for display
      scores = {
        ...scores,
        engagementTotal: 5 - (scores.engagementTotal || 0)
      };
    }

    const config = createAssessmentConfig({ ...assessmentResult, scores }, {
      assessmentType: assessmentType,
      assessmentName: 'occupational-assessment',
      assessmentDisplayName: assessmentName,
      redoRoute: '/panel/learn/occupational-assessment',
      completeRoute: '/panel/insights',
      scoreLabel: scoreLabel,
      subtitleMapping: {
        High: isCBI ? 'High Burnout Risk' : isUWES ? 'High Work Engagement' : isEngagement ? 'High Employee Engagement' : 'High Score',
        Moderate: isCBI ? 'Moderate Burnout Risk' : isUWES ? 'Moderate Work Engagement' : isEngagement ? 'Moderate Employee Engagement' : 'Moderate Score',
        Low: isCBI ? 'Low Burnout Risk' : isUWES ? 'Low Work Engagement' : isEngagement ? 'Low Employee Engagement' : 'Low Score'
      },
      visualMessage: "You've completed the assessment!",
      resultsTitle: isCBI ? "Here's your burnout analysis" : isUWES ? "Here's your work engagement analysis" : isEngagement ? "Here's your employee engagement analysis" : "Here's your assessment analysis"
    });
    
    return <AssessmentCompletionTemplate config={config} />;
  } catch (error) {

    navigate('/panel/learn/');
    return null;
  }
};

export default OccupationalAssessmentCompletionPage;



